import {throwError as observableThrowError,  Observable , forkJoin, of,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppConfig } from '../app.config';
import { map, catchError, takeWhile } from 'rxjs/operators';

import { GlobalsService } from './globals.service';
import { DataService } from './datamanager.service';


@Injectable()
export class SecretariaConfigService {
    alive = true;

    constructor(
        private http: HttpClient,
        private dataService: DataService,
        private globalStorage: GlobalsService,
        private config: AppConfig,
    ) {}

    getConfig(grup) {
        const params = <any>{
            'accio': 'WsGetSecretariaConfiguracio',
            'params': <any>{
                'secretaria_id': this.globalStorage.getItem('secretaria'),
                'grup' : grup
            }
        };

        const ruta = this.config.apiUrl + this.config.wsapi;

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const body = JSON.stringify(params);

        return this.http.post<any>(ruta, body, {headers: headers})
            .pipe(map((resultado) => {
                const data = resultado.data;
                let config = {};

                data[0].forEach(d => {
                    config[d.propietat] = d.valor
                })
                return config;
            }))
            .pipe(catchError((error: any) => {
                console.log(error)
                return observableThrowError('MAL');
            }));
    }

    // Retorna un observable de booleans amb els permisos de l'usuari que s'envien com argument
    getPermisos(permisos: object): Observable<any>{
        const observables = Object.keys(permisos).map(permisBD => {
        const params = {
            'accio': 'WsHasPermis',
            'params': {
                'secretaria_id': this.globalStorage.getItem('secretaria'),
                'permission': permisBD
            }
        };

        return this.dataService.getData(params).pipe(
            map(data => ({ [permisBD]: data[0] })),
            catchError(() => of({ [permisBD]: false }))
        );
        });

        return forkJoin(observables).pipe(
            map(results => results.reduce((acc, curr) => ({ ...acc, ...curr }), {}))
        );
    }

    getConvocatoriaActiva(): Observable<any> {
        const params = {
            'accio': 'WsGetConvocatoriaActiva',
            'params': {
                'secretaria_id': this.globalStorage.getItem('secretaria')
            }
        };

        return this.dataService.getData(params).pipe(
            takeWhile(() => this.alive),
            map(data => (data[0] instanceof Object ? data[0] : null))
        );
    }

    getConvocatoriesSecretaria(all = false, secretaria = null): Observable<any> {
        const action = all ? 'WsGetConvocatories' : 'WsGetConvocatoriesSecretaria';
        const sec = secretaria === null || secretaria === undefined ? this.globalStorage.getItem('secretaria') : secretaria;

        const params = <any>{
            'accio': action,
            'params': <any> {
                'secretaria_id' : sec
            }
        };

        return this.dataService.getData(params).pipe(
            takeWhile(() => this.alive),
            map(data =>
                data[0].sort((a, b) => b.nom.localeCompare(a.nom))
            )
        );
    }

    isAdmin(): Observable<boolean>{
        const params = <any>{
            'accio': 'WsGetRolePersona',
            'params': <any>{
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
                'user_id' : this.globalStorage.getItem('currentUser'),
                'all_roles': false
            }
        };

        return this.dataService.getData(params).pipe(
            takeWhile(() => this.alive),
            map(data => data[0].id == 12)
        );
    }

    getCursos(secretariaId): Observable<any> {
        const params = {
            'accio': 'WsGetCursos',
            'params': {
                'secretaria_id': secretariaId
            }
        };

        return this.dataService.getData(params).pipe(
            takeWhile(() => this.alive),
            map(data => (data[0] instanceof Object ? data[0] : null))
        );
    }
}
